import LoginInjector from '../../LoginInjector';

const NotLoginContentTemplate = ({ children, userInfo }) => {
  if (userInfo.isLogin === true) {
    return null;
  }
  return children;
};

export default LoginInjector(NotLoginContentTemplate);
